import { Modal } from "@mui/material";
import React from "react";
import Form from "./form";

interface Props {
  buyModalstatus: any;
  onClose: () => void;
}
const NftBuyModal = ({ buyModalstatus, onClose }: Props) => {
  return (
    <Modal
      onClose={onClose}
      open={buyModalstatus.status}
      style={{
        background: "#111111dd",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Form handleClose={onClose} buyModalstatus={buyModalstatus} />
    </Modal>
  );
};

export default NftBuyModal;
